export default {
    data() {
        return {

        }
    },

    watch: {

    },

    created() {

    },

    methods: {
        openPage() {
            window.open(this._link + 'active/detail?id=' + this.data.id + '&type=' + this.data.type)
            // this.$router.push({
            //     name: 'active-detail',
            //     query: {
            //         type: this.data.type,
            //         id: this.data.id,
            //         // data: this.$Encrypt(JSON.stringify(this.data))
            //     }
            // })
        }
    }
}
